"use strict";
exports.__esModule = true;
exports.PROPERTY = exports.WATCHLISTED_PROPERTY = void 0;
var PROPERTY = {
    PROPERTY_STATUS: {
        SUBMITTED: 'SUBMITTED',
        APPROVED: 'APPROVED',
        REJECTED: 'REJECTED'
    }
};
exports.PROPERTY = PROPERTY;
var WATCHLISTED_PROPERTY = {
    STATUS: {
        PENDING: 'pending',
        DECLINED: 'declined'
    }
};
exports.WATCHLISTED_PROPERTY = WATCHLISTED_PROPERTY;
